/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Add_IgInputs */

const en_link_editor_add_ig = /** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add IG`)
};

const es_link_editor_add_ig = /** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir IG`)
};

const fr_link_editor_add_ig = /** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter IG`)
};

const de_link_editor_add_ig = /** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IG hinzufügen`)
};

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const ja_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const zh_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const ar_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const id_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const it_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const ru_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const pt_link_editor_add_ig = en_link_editor_add_ig;

/** @type {(inputs: Link_Editor_Add_IgInputs) => LocalizedString} */
const ko_link_editor_add_ig = en_link_editor_add_ig;

/**
* | output |
* | --- |
* | "Add IG" |
*
* @param {Link_Editor_Add_IgInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_add_ig = /** @type {((inputs?: Link_Editor_Add_IgInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Add_IgInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_add_ig(inputs)
	if (locale === "es") return es_link_editor_add_ig(inputs)
	if (locale === "fr") return fr_link_editor_add_ig(inputs)
	if (locale === "de") return de_link_editor_add_ig(inputs)
	if (locale === "ja") return ja_link_editor_add_ig(inputs)
	if (locale === "zh") return zh_link_editor_add_ig(inputs)
	if (locale === "ar") return ar_link_editor_add_ig(inputs)
	if (locale === "id") return id_link_editor_add_ig(inputs)
	if (locale === "it") return it_link_editor_add_ig(inputs)
	if (locale === "ru") return ru_link_editor_add_ig(inputs)
	if (locale === "pt") return pt_link_editor_add_ig(inputs)
	return ko_link_editor_add_ig(inputs)
});